import Vue from 'vue';
import $ from 'jquery';
import Paginator from 'components/widgets/Paginator.vue';
import Project from 'src/api/project';
export default Vue.extend({
    components: { Paginator },
    beforeRouteLeave(to, from, next) {
        if (this.refreshTimeout !== null) {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
    },
    props: {
        working: { type: Boolean, default: false },
        pageNumber: { type: Number, default: 1 },
        gridData: { type: Object, default: () => { } },
        fetchDataFn: { type: Function, required: true },
        pageSize: { type: Number, default: 4 },
        sortOptions: { type: Array, default: () => [] }
    },
    data() {
        return {
            refreshTimeout: undefined,
            sortBy: this.sortOptions.length > 0 ? this.sortOptions[0].key : ''
        };
    },
    computed: {
        isResultsLoaded() {
            return this.gridData.results;
        },
        pageCount() {
            return Math.ceil(this.gridData.count / this.pageSize);
        },
        projectId() {
            return this.$route.params.projectId;
        }
    },
    watch: {
        projectId: function (val) {
            this.refreshPage(1, true);
        }
    },
    mounted() {
        if (this.refreshTimeout === undefined) {
            this.refreshTimeout = setTimeout(this.refetch, Project.REFRESH_INTERVAL);
        }
        // Init dropdown
        this.$nextTick(() => {
            $(this.$el).find('.ui.dropdown').dropdown({
                onChange: (v) => {
                    if (v !== this.sortBy) {
                        this.sortBy = v;
                        this.refreshPage(this.pageNumber, true);
                    }
                }
            }).dropdown('set selected', this.sortBy);
        });
    },
    beforeDestroy() {
        if (this.refreshTimeout !== null) {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
    },
    methods: {
        // This method refreshes the page by pagenumber without invoking another timeout loop
        refreshPage(page, force = false) {
            this.fetchDataFn(page, this.sortBy, force);
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = setTimeout(this.refetch, Project.REFRESH_INTERVAL);
        },
        refetch(fn) {
            this.fetchDataFn(this.pageNumber, this.sortBy, true, true).then(() => {
                this.refreshTimeout = this.refreshTimeout !== null ? setTimeout(this.refetch, Project.REFRESH_INTERVAL) : null;
            });
        }
    }
});
